import {
  SET_GENERAL_SECRETARY_DATA,
  GENERAL_SECRETARY_LOADER,
  DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  loader: false,
  pageData: {},
};

const generalSecretaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_SECRETARY_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_GENERAL_SECRETARY_DATA: {
      return {
        ...state,
        pageData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          pageData: {
            ...state.pageData,
            fileViewCount: (state.pageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          pageData: {
            ...state.pageData,
            downloadCount: (state.pageData?.downloadCount || 0) + 1,
          },
        };
    }

    default:
      return state;
  }
};

export default generalSecretaryReducer;
